import { get,post,put,del } from './request'

export default {
//非会员接口
    getPolicyList(params) {
        return get('/policy/getList', params)
    },
    getNewsList(params) {
        return get('/news/getList', params)
    },
    getPoDetail(id) {
        return get(`/policy/${id}`)
    },
    getNesDetail(id) {
        return get(`/news/${id}`)
    },
    getAllpeo() {
        return get('/recteam/getAll')
    },
    getCustome() {
        return get('/customer/getAll')
    },
    //所有联系方式
    getInfo() {
        return get('/contact/getAll')
    },
    //搜索
    onSearch(params, config = {}) {
        return post('/search/query',params,config)
    },
//会员相关接口
    //用户注册
    onRegister(params){
        return post ('/user/register',params,{debounce:true})
    },
    //获取验证码
    sendCode(params){
        return post('/user/sendCode',params,{debounce:true})
    },
    //重置密码
    onReset(params){
        return post('/user/resetPassword',params,{debounce:true})
    },
    //重置密码获取验证码
    onResetsendCode(params){
        return post('/user/sendResetPasswordCode',params,{debounce:true})
    },
    //用户登录
    onLogin(params){
        return post('/user/login',params,{debounce:true})
    },
    //用户登出
    onLogout(){
        return post('/user/logout')
    },
    //获取用户是否初次登录
    isFirstLogin(){
        return get('/user/isFirstLogin')
    },
    //设置用户非首次登录
    setnoFirst(){
        return put('/user/isFirstLogin')
    },
    //获取用户状态
    getUserStatus(){
        return get('/user/status')
    },
    //获取用户资料
    getUserInfo(){
        return get('/user/userdetail')
    },
    //获取公司资料
    getCompInfo(){
        return get('/user/companydetail')
    },
    //设置用户资料
    setUserInfo(params){
        return post('/user/userdetail',params,{debounce:true})
    },
    //设置公司资料
    setCompInfo(params){
        return post('/user/companydetail',params,{debounce:true})
    },
    //修改密码
    changePass(params){
        return post('/user/changePassword',params,{debounce:true})
    },
    //文件上传
    upload(params){
        return post('/file/upload',params,{debounce:true})
    },
    //删除文件
    deleteFile(params){
        return del('/uploadfile/delete?indicatorId='+params,{},{debounce:true})
    },
    //指标文件上传
    uploadfile(params){
        return post('/uploadfile',params)
    },
    //用户修改文件备注
    setFileRemark(params){
        return post('/uploadfile/setFileRemark',params,{debounce:true})
    },

    //提交文件
    onSubFile(){
        return post('/fileManagement/submit',{},{debounce:true})
    },
    //文件查询
    //查询所有维度
    getDimensions(){
        return get('/fileManagement/getDimensions')
    },
    //根据维度id查询主类别
    getCategory(params){
        return get('/fileManagement/getCategory',params)
    },
    //根据主类别id查询子类别
    getSubcategory(params){
        return get('/fileManagement/getSubcategory',params)
    },
    //根据主类别id查询指标及文件
    getIndicator(params){
        return get('/fileManagement/getIndicatorByCategoryId',params)
    },
    getIndicatorBySub(params){
        return get('/fileManagement/getIndicatorBySubcategoryId',params)
    },
    //根据子类别ID查询指标及文件评分

    //获得企业积分看板数据
    getScoreboard(){
        return get('/scoreboard/data')
    },
    //获取esg得分及维度
    getEsgScore(){
        return get('/esgScore/getEsgScore')
    },
    //获得具体得分
    getScoreDetail(){
        return get('/esgScore/getScoreDetail')
    },
    //获取用户总评分
    getRating(){
        return get('/esgEvaluation/getRating')
    },
    //获取评价改进信息
    getEvaluationImprovement(){
        return get('/evaluationlmprovement/getEvaluationImprovement')
    },
    //查询未满评分文件
    getImprovementIndicators(params){
        return get('/evaluationlmprovement/getImprovementIndicators',params,{debounce:true})
    },
    //取消提交
    withdrawSubmit(){
        return post('/fileManagement/withdrawSubmit',{},{debounce:true})
    },
    //改进文件提交
    evaSubmit(){
        return post('/evaluationlmprovement/submit',{},{debounce:true})
    },
    //全部ESG课程
    getTraining(){
        return get('/training/courses')
    },
    //查询当前用户的会员名和企业名
    getTranInfo(){
        return get('/training/userInfo')
    },
    //提交定制课程内容
    subTraining(params){
        return post('/training/custom',params,{debounce:true})
    },

    //获取企业信息和得分
    getRepSum(){
        return get('/report/summary')
    },
    
    //换绑手机号
    changePhone(params){
        return post('/user/resetPhone',params,{debounce:true})
    },
    //换绑手机号验证码
    sendChangePhone(params){
        return post('/user/sendResetPhoneCode',params,{debounce:true})
    },

    //获取审核年份
    getYears(){
        return get('/report/getYears')
    },

    //根据年份获取报告证书
    getSummaryByYear(year){
        return get('/report/getSummaryByYear/' + year)
    },
}